module.exports = __webpack_public_path__ + "static/media/004.c1d4fd4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/004.jpg
// module id = 301
// module chunks = 0